import { message, Select, Row, Col } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  InputNumberItem,
  DatePickerItem,
  ErrorItem,
  SelectItem,
} from "../../../../Components/Items";
import CamposRepse from "../CamposRepse";
import moment from "moment";

const { Option } = Select;

// Registro patronal IMSS: 11 posiciones agrupadas 3-5-2-1, como lo presenta el IMSS
// ("Y73-37289-10-7"). Los guiones son sólo de lectura: el timbrado los quita porque el
// patrón de @RegistroPatronal en nomina12 sólo admite letras y dígitos.
const formatearRegistroIMSS = (valor) => {
  const soloAlfanumericos = valor.replace(/[^a-zA-Z0-9]/g, "").substring(0, 11).toUpperCase();
  if (soloAlfanumericos.length <= 3) return soloAlfanumericos;
  if (soloAlfanumericos.length <= 8) return `${soloAlfanumericos.slice(0, 3)}-${soloAlfanumericos.slice(3)}`;
  if (soloAlfanumericos.length <= 10) return `${soloAlfanumericos.slice(0, 3)}-${soloAlfanumericos.slice(3, 8)}-${soloAlfanumericos.slice(8)}`;
  return `${soloAlfanumericos.slice(0, 3)}-${soloAlfanumericos.slice(3, 8)}-${soloAlfanumericos.slice(8, 10)}-${soloAlfanumericos.slice(10)}`;
};

class EditarRegistroPatronal extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
    objetoClasesRiesgo: null,
    objetoFracciones: null,
    objetoEntidadesFederativas: null,
    objetoMunicipios: null,
    objetoColonias: null,
    todasColonias: [],
    claseRiesgoSeleccionada: null,
    todasFracciones: [],
    todasClasesRiesgo: [],
    hayFraccionesDeLaClase: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible });
      if (this.props.visible && this.props.registroPatronalId) {
        this.formRef.current && this.formRef.current.resetFields();
        this.setState({
          objetoFracciones: null, objetoMunicipios: null,
          objetoColonias: null, claseRiesgoSeleccionada: null,
          hayFraccionesDeLaClase: false,
        });
        this.consultarDatos(() => {
          this.consultarDatosRegistroPatronal(this.props.registroPatronalId);
        });
      }
    }
  }

  consultarDatos(callback) {
    this.setState({ loading: true });
    axios
      .post(
        "registrosPatronales/selectDatosParaRegistroPatronal",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          const { clasesRiesgos, fracciones, entidadesFederativas } = res.data;
          this.setState({
            todasFracciones: fracciones,
            todasClasesRiesgo: clasesRiesgos,
            objetoClasesRiesgo: clasesRiesgos.map((c) => (
              <Option value={c._id} key={c._id}>{c.c_RiesgoPuesto + " - " + c.Descripcion}</Option>
            )),
            objetoEntidadesFederativas: [
              <Option value="catalogo_empleado" key="catalogo_empleado">
                Tomar del catálogo de empleados - Domicilio Actual
              </Option>,
              ...entidadesFederativas.map((e) => (
                <Option value={e._id} key={e._id}>{e.nombre}</Option>
              )),
            ],
          }, callback);
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al cargar los datos");
      });
  }

  consultarDatosRegistroPatronal(id) {
    this.setState({ loading: true });
    axios
      .post(
        "registrosPatronales/datosRegistroPatronal",
        { registroPatronalId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          message.error("No se encontraron los datos del registro patronal");
        } else {
          const {
            registroPatronalIMSS, claseRiesgoId, fraccionRiesgoId,
            entidadFederativaId, municipioId, coloniaId, colonia, localidad,
            vigencias,
            folioRepse, fechaRepse, estatusRepse, actividadRepse,
          } = res.data.data;

          // Cargar fracciones de la clase guardada
          if (claseRiesgoId) {
            this.cargarFracciones(claseRiesgoId, fraccionRiesgoId);
          }
          // Cargar municipios del estado guardado
          if (entidadFederativaId && entidadFederativaId !== "catalogo_empleado") {
            this.onChangeEstado(entidadFederativaId, true);
          }
          // Cargar colonias del municipio guardado
          if (municipioId) {
            this.onChangeMunicipio(municipioId, true);
          }

          const vigenciasMapped = Array.isArray(vigencias)
            ? vigencias.map((v) => ({
                ...v,
                fechaVigencia: v.fechaVigencia ? moment(v.fechaVigencia) : null,
              }))
            : [];

          this.formRef.current && this.formRef.current.setFieldsValue({
            // Se reformatea al cargar para que un registro guardado con el
            // agrupamiento anterior (2-7-2) o sin guiones se vea con el del IMSS,
            // y quede así en la base al guardar.
            registroPatronalIMSS: formatearRegistroIMSS(registroPatronalIMSS || ""),
            claseRiesgoId,
            fraccionRiesgoId,
            entidadFederativaId,
            municipioId,
            coloniaId,
            colonia,
            localidad,
            vigencias: vigenciasMapped,
            folioRepse,
            // DatePickerItem trabaja con moment, no con dayjs.
            fechaRepse: fechaRepse ? moment(fechaRepse) : null,
            estatusRepse,
            actividadRepse,
          });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  // La liga se resuelve por el número de clase (claseNumero, que el servidor normaliza
  // desde el romano del IMSS) y no sólo por claseRiesgoId: ese campo viene denormalizado
  // en cada fracción y si está vacío o apunta a otro documento del catálogo el select se
  // quedaba sin opciones. "99 - No aplica" simplemente no tiene fracciones.
  fraccionesDeLaClase(claseId) {
    if (!claseId) return [];
    const clase = this.state.todasClasesRiesgo.find(
      (c) => c._id?.toString() === claseId.toString()
    );
    const numeroClase =
      clase?.c_RiesgoPuesto != null ? clase.c_RiesgoPuesto.toString().trim() : null;

    return this.state.todasFracciones.filter(
      (f) =>
        (numeroClase && f.claseNumero === numeroClase) ||
        f.claseRiesgoId?.toString() === claseId.toString()
    );
  }

  cargarFracciones(claseId, fraccionRiesgoIdGuardada) {
    const fracciones = this.fraccionesDeLaClase(claseId);

    // Si la fracción guardada no cae dentro de la clase (registro viejo o catálogo
    // recargado) se agrega como opción para que el select muestre su descripción y no
    // el id crudo.
    const guardada = fraccionRiesgoIdGuardada
      ? this.state.todasFracciones.find(
          (f) => f._id?.toString() === fraccionRiesgoIdGuardada.toString()
        )
      : null;
    const lista =
      guardada && !fracciones.some((f) => f._id?.toString() === guardada._id?.toString())
        ? [guardada, ...fracciones]
        : fracciones;

    this.setState({
      claseRiesgoSeleccionada: claseId || null,
      hayFraccionesDeLaClase: lista.length > 0,
      objetoFracciones: lista.map((f) => (
        <Option
          value={f._id}
          key={f._id}
          title={f.descricion_fraccion}
          busqueda={`${f.fraccion} ${f.actividad || ""} ${f.descricion_fraccion || ""}`}
        >
          {f.fraccion + " - " + (f.actividad || f.descricion_fraccion)}
        </Option>
      )),
    });
  }

  onChangeClaseRiesgo(claseId) {
    this.formRef.current.setFieldsValue({ fraccionRiesgoId: undefined });
    this.cargarFracciones(claseId);
  }

  // Texto único para placeholder y tooltip: dice por qué no se puede elegir fracción.
  textoFraccion() {
    if (!this.state.claseRiesgoSeleccionada) return "Selecciona primero una clase de riesgo";
    if (this.state.hayFraccionesDeLaClase) return "Selecciona la fracción";
    if (!this.state.todasFracciones.length) return "El catálogo de fracciones de riesgo está vacío";
    return "Esta clase de riesgo no tiene fracciones";
  }

  onChangeEstado(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({ municipioId: undefined, coloniaId: undefined });
      this.setState({ objetoMunicipios: null, objetoColonias: null });
    }
    axios
      .post("municipios/selectMunicipios", { estadoId: value }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoMunicipios: res.data.map((m) => (
              <Option value={m._id} key={m._id}>{m.nombre}</Option>
            )),
          });
        }
      });
  }

  onChangeMunicipio(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({ coloniaId: undefined });
      this.setState({ objetoColonias: null });
    }
    axios
      .post("colonias/selectColonias", { municipioId: value }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasColonias: res.data,
            objetoColonias: res.data.map((c) => (
              <Option value={c._id} key={c._id}>{c.cp + " - " + c.nombre}</Option>
            )),
          });
        }
      });
  }

  onSearchColonia(value) {
    if (value.toString().length === 5) {
      axios
        .post("colonias/buscarCP", { cp: value }, { headers: this.props.headersToken })
        .then((res) => {
          if (res.data.status === 404) {
            message.info("No se encontró el código postal");
          } else {
            this.formRef.current.setFieldsValue({
              entidadFederativaId: res.data.estadoId,
              municipioId: res.data.municipioId,
            });
            this.onChangeEstado(res.data.estadoId, true);
            this.onChangeMunicipio(res.data.municipioId, true);
          }
        });
    }
  }

  onSelectColoniaId(coloniaId) {
    const colonia = this.formRef.current.getFieldValue("colonia");
    if (!colonia) {
      const nombre = this.state.todasColonias.find(
        (c) => c._id.toString() === coloniaId.toString()
      )?.nombre;
      this.formRef.current.setFieldsValue({ colonia: nombre });
    }
  }

  onFinishFailed(e) { ErrorItem(e); }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "registrosPatronales/editarRegistroPatronal",
        {
          ...values,
          // Explícito en null: editarRegistroPatronal hace findByIdAndUpdate, así que si
          // se cambia a una clase sin fracciones y no se manda el campo, se quedaría
          // guardada la fracción anterior.
          fraccionRiesgoId: values.fraccionRiesgoId ?? null,
          registroPatronalId: this.props.registroPatronalId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Registro patronal actualizado exitosamente");
          this.cerrarModal();
        } else {
          message.error("No se pudo actualizar el registro patronal");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  cerrarModal = () => {
    this.props.cerrarEditarRegistroPatronal();
    if (this.formRef.current) this.formRef.current.resetFields();
    this.setState({
      objetoFracciones: null, objetoMunicipios: null,
      objetoColonias: null, claseRiesgoSeleccionada: null,
      hayFraccionesDeLaClase: false,
    });
  };

  render() {
    const thStyle = {
      border: "1px solid #f0f0f0",
      padding: "8px 12px",
      fontWeight: 600,
      fontSize: 13,
      textAlign: "left",
    };
    const tdStyle = {
      border: "1px solid #f0f0f0",
      padding: "6px 8px",
      verticalAlign: "middle",
    };

    return (
      <ModalItem
        title="Editar Registro Patronal"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal}
        width={800}
      >
        <Form
          ref={this.formRef}
          name="modalEditarRegistroPatronal"
          layout
          bottom={
            <ButtonItem type="primary" htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}>
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem
            name="registroPatronalIMSS"
            label="Registro Patronal IMSS"
            required
            margin
            tooltip="Formato: XXX-XXXXX-XX-X"
          >
            <InputItem
              placeholder="Ej: Y73-37289-10-7"
              style={{ fontFamily: "monospace" }}
              onChange={(e) => {
                const formateado = formatearRegistroIMSS(e.target.value);
                this.formRef.current.setFieldsValue({ registroPatronalIMSS: formateado });
              }}
            />
          </FormItem>

          <FormItem name="claseRiesgoId" label="Clase de Riesgo" required margin>
            <SelectItem
              placeholder="Selecciona la clase de riesgo"
              onChange={this.onChangeClaseRiesgo.bind(this)}
            >
              {this.state.objetoClasesRiesgo}
            </SelectItem>
          </FormItem>

          {/* Obligatoria sólo cuando la clase elegida tiene fracciones: con
              "99 - No aplica" no hay ninguna que escoger. */}
          <FormItem
            name="fraccionRiesgoId"
            label="Fracción de Riesgo"
            required={this.state.hayFraccionesDeLaClase}
            margin
            tooltip={this.state.hayFraccionesDeLaClase ? undefined : this.textoFraccion()}
          >
            <SelectItem
              placeholder={this.textoFraccion()}
              disabled={!this.state.hayFraccionesDeLaClase}
              showSearch
              filterOption={(input, option) =>
                `${option?.busqueda ?? option?.children ?? ""}`
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {this.state.objetoFracciones}
            </SelectItem>
          </FormItem>

          <FormItem name="entidadFederativaId" label="Entidad Federativa" required margin>
            <SelectItem
              placeholder="Selecciona la entidad federativa"
              onChange={(value) => {
                if (value !== "catalogo_empleado") {
                  this.onChangeEstado(value, false);
                } else {
                  this.formRef.current.setFieldsValue({ municipioId: undefined, coloniaId: undefined });
                  this.setState({ objetoMunicipios: null, objetoColonias: null });
                }
              }}
            >
              {this.state.objetoEntidadesFederativas}
            </SelectItem>
          </FormItem>

          <Row >
            <Col span={24}>

              <FormItem label="Municipio" name="municipioId" margin>
                <SelectItem
                  placeholder="Municipio"
                  onChange={this.onChangeMunicipio.bind(this)}
                >
                  {this.state.objetoMunicipios === null ? (
                    <Option disabled>Elija primero un estado</Option>
                  ) : (
                    this.state.objetoMunicipios
                  )}
                </SelectItem>
              </FormItem>
              <FormItem label="Código Postal" name="coloniaId" margin>
                <SelectItem
                  placeholder="Colonia"
                  onSearch={this.onSearchColonia.bind(this)}
                  onSelect={this.onSelectColoniaId.bind(this)}
                >
                  {this.state.objetoColonias === null ? (
                    <Option disabled>Elija primero un municipio</Option>
                  ) : (
                    this.state.objetoColonias
                  )}
                  <Option disabled>Busque por código postal</Option>
                </SelectItem>
              </FormItem>
            </Col>
          </Row>

          {/* ── REPSE ── */}
          <CamposRepse />

          {/* ── Vigencias ── */}
          <Form.List name="vigencias">
            {(fields, { add, remove }) => (
              <>
                <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 16 }}>
                  <thead>
                    <tr style={{ backgroundColor: "#fafafa" }}>
                      <th style={thStyle}>Fecha Vigencia</th>
                      <th style={thStyle}>Prima de Riesgo</th>
                      <th style={{ ...thStyle, width: 60 }}>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fields.map(({ key, name, fieldKey, ...restField }) => (
                      <tr key={key}>
                        <td style={tdStyle}>
                          <FormItem
                            {...restField}
                            name={[name, "fechaVigencia"]}
                            fieldKey={[fieldKey, "fechaVigencia"]}
                            required
                            noStyle
                          >
                            <DatePickerItem placeholder="Fecha de vigencia" style={{ width: "100%" }} />
                          </FormItem>
                        </td>
                        <td style={tdStyle}>
                          <FormItem
                            {...restField}
                            name={[name, "primaRiesgo"]}
                            fieldKey={[fieldKey, "primaRiesgo"]}
                            required
                            noStyle
                          >
                            <InputNumberItem
                              placeholder="0.0000"
                              min={0}
                              step={0.0001}
                              stringMode
                              style={{ width: "100%" }}
                            />
                          </FormItem>
                        </td>
                        <td style={{ ...tdStyle, textAlign: "center" }}>
                          <ButtonItem
                            type="default"
                            danger
                            icon={<DeleteOutlined />}
                            onClick={() => remove(name)}
                            size="small"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <FormItem noStyle>
                  <ButtonItem
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    style={{ marginTop: 8 }}
                  >
                    Agregar Vigencia
                  </ButtonItem>
                </FormItem>
              </>
            )}
          </Form.List>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EditarRegistroPatronal);